var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.drawerTitle,
            visible: _vm.drawerVisible,
            size: "80%",
            "custom-class": "menuDetailDrawer",
            "destroy-on-close": "",
            "before-close": _vm.handleCancel,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _vm.BRAND_VISIBLE_TYPES.includes(_vm.originParams.type)
            ? [
                _c("menuDetailBrand", {
                  attrs: { entry: _vm.entry, originParams: _vm.originParams },
                }),
              ]
            : _vm.originParams.type === "entity"
            ? [
                _c("menuDetailEntity", {
                  attrs: { entry: _vm.entry, originParams: _vm.originParams },
                }),
              ]
            : _vm.originParams.type === "movie"
            ? [
                _c("menuDetailMovie", {
                  attrs: { entry: _vm.entry, originParams: _vm.originParams },
                }),
              ]
            : [
                _c("menuDetailCommon", {
                  attrs: { entry: _vm.entry, originParams: _vm.originParams },
                }),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }